import {h, Fragment} from "preact"
import { useSizeOptions, useLoadMore } from "@nosto/preact";
import { defaultConfig, sizes } from "../config";
import Pagination from "./Pagination";
import Select from "./elements/Select";

export default function BottomToolbar() {
  const { from, to, size, total, handleSizeChange, sizeOptions } =
    useSizeOptions(sizes, defaultConfig.serpSize);

  const options = sizeOptions.map((v) => ({
    value: v,
    label: `${v} items per page`,
  }));
  const { loadMore, href } = useLoadMore();

  return (
    <div class="ns-bottom-toolbar ns-d-flex ns-flex-column ns-align-items-center ns-justify-content-center ns-border-box">
      {to < total && (
        <a class="ns-load-more-btn" onClick={loadMore} href={href}>
          Load More
        </a>
      )}
    </div>
  );
}
